var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuAmbApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#7C756F",
    fillRule: "nonzero",
    stroke: "#7C756F",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.819 0H1.023C.46 0 0 .459 0 1.023v7c0 .565.46 1.024 1.023 1.024H8.82c.564 0 1.023-.46 1.023-1.023v-7C9.842.458 9.382 0 8.819 0zm-.205 7.819H1.228V1.228h7.386v6.591zM19.977 0H12.18c-.564 0-1.023.459-1.023 1.023v7c0 .565.46 1.024 1.023 1.024h7.796c.564 0 1.023-.46 1.023-1.023v-7C21 .458 20.54 0 19.977 0zm-.205 7.819h-7.386V1.228h7.386v6.591h0zM8.819 10.33H1.023C.46 10.33 0 10.79 0 11.355v7c0 .565.46 1.024 1.023 1.024H8.82c.564 0 1.023-.46 1.023-1.023v-7c0-.565-.46-1.024-1.023-1.024zm-.205 7.82H1.228v-6.591h7.386v6.59zM19.977 10.33H12.18c-.564 0-1.023.46-1.023 1.024v7c0 .565.46 1.024 1.023 1.024h7.796c.564 0 1.023-.46 1.023-1.023v-7c0-.565-.46-1.024-1.023-1.024zm-.205 7.82h-7.386v-6.591h7.386v6.59h0z",
    transform: "translate(-20.000000, -724.000000) translate(20.000000, 724.000000) translate(0.000000, 1.000000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAmbApp);
export default __webpack_public_path__ + "static/media/menu-amb-app.e158b6d9.svg";
export { ForwardRef as ReactComponent };